import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=9f054960"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports